<template>
    <div>
        <span class="label published" v-if="internalValue == 1">Publié</span>
        <span class="label unpublished" v-if="internalValue == 0">non publié</span>
        <span class="label expired" v-if="internalValue == -1">expiré</span>
        <span class="label soon" v-if="internalValue == 2">Bientot</span>
    </div>
</template>

<script>
    export default {
        name: 'Published',
        props: ['value','label','name','placeholder'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Published.vue